const updateRow = ({ object, key, items }) => {
  const {
    name,
    telephone,
    status,
  } = object;

  return items.map(item =>
    item.id === key ? { ...item, name, telephone, status } : item
  );
}

export default updateRow;
